var _defs, _path, _path2, _path3, _path4, _rect, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n         fill: var(--icon-color, #7c878e);\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m44.23,140.1h111.59V48.06H44.23v92.04Zm117.51,4.48H38.27V43.58h123.46v101Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m48.72,108.92l50.57,31.18,50.57-31.18H48.72Zm50.57,35.66h0l-59.51-35.66c0-1.47-1.51-1.47,0-2.97q0-1.47,1.47-1.47h117.51q1.51,0,1.51,1.47c1.47,1.51,0,1.51,0,2.97l-59.51,35.66h-1.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m68.02,143.07c-1.47,0-2.98-1.47-2.98-2.97v-17.79c0-1.51,1.51-1.51,2.98-1.51s1.51,0,1.51,1.51v17.79c0,1.51,0,2.97-1.51,2.97Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.49,143.07c-1.51,0-2.98-1.47-2.98-2.97v-17.79c0-1.51,1.47-1.51,2.98-1.51s1.47,0,1.47,1.51v17.79c0,1.51,0,2.97-1.47,2.97Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 97.78,
    y: 52.49,
    width: 4.49,
    height: 53.45
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.75,55.47H41.25c-1.47,0-2.98-1.47-2.98-2.97,0,0,1.51-1.47,2.98-1.47h117.51c1.51,0,2.98,1.47,2.98,1.47,0,1.51-1.47,2.97-2.98,2.97Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.14,156.42h-14.9c-1.47,0-2.98-1.47-2.98-2.97s1.51-1.47,2.98-1.47h14.9c1.47,0,2.98,0,2.98,1.47s-1.51,2.97-2.98,2.97Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m81.41,156.42h-14.86c-1.51,0-1.51-1.47-1.51-2.97s0-1.47,1.51-1.47h14.86c1.51,0,2.98,0,2.98,1.47s-1.47,2.97-2.98,2.97Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m108.18,156.42h-16.37s-1.47-1.47-1.47-2.97,1.47-1.47,1.47-1.47h16.37s1.51,0,1.51,1.47-1.51,2.97-1.51,2.97Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m133.49,156.42h-14.9c-1.47,0-2.94-1.47-2.94-2.97s1.47-1.47,2.94-1.47h14.9q1.47,0,1.47,1.47c0,1.51,0,2.97-1.47,2.97Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m158.75,156.42h-14.86c-1.47,0-2.98-1.47-2.98-2.97s1.51-1.47,2.98-1.47h14.86c1.51,0,2.98,0,2.98,1.47s-1.47,2.97-2.98,2.97Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSand);
export default __webpack_public_path__ + "static/media/Sand.d3528756dfb4462d6ae52e4ed3243e13.svg";
export { ForwardRef as ReactComponent };